import styled from "@emotion/styled";
import { i18n, openContactModal } from "src/common";
import { Button, Flex, StatusMessage } from "src/components";
import WarningIcon from "src/assets/images/warning.png";

const ButtonContainerStyle = styled.div({
  marginTop: 32,
});

export interface CalculationsErrorProps {
  title?: string;
  subtitle?: string;
  onRetry?: () => void;
}

export const CalculationsError: React.FC<CalculationsErrorProps> = ({
  title = i18n.t("components.other.calculationsError.title"),
  subtitle = i18n.t("components.other.calculationsError.subtitle"),
  onRetry,
}) => {
  const Buttons = () => (
    <ButtonContainerStyle>
      <Flex align="center" justify="center" gap={16}>
        <Button btnType="textBlack" onClick={() => openContactModal()}>
          {i18n.t("components.other.calculationsError.requestHelp")}
        </Button>
        <Button btnType="primary" onClick={() => onRetry && onRetry()}>
          {i18n.t("components.other.calculationsError.tryAgain")}
        </Button>
      </Flex> 
    </ButtonContainerStyle>
  )

  return (
    <StatusMessage title={title} subtitle={subtitle} buttons={<Buttons />} icon={<img src={WarningIcon} alt="warning" />} />
  )
}

export default CalculationsError


